import type { LandingCommunicationContent } from '../types';

export const kloutsaleHome: LandingCommunicationContent = {
  pageKey: 'kloutsale.home',
  app: 'kloutsale',
  audience: 'brands',
  hero: {
    eyebrow: 'Kloutsale for brands',
    headline: 'Add active sales to your passive marketing.',
    subheadline:
      'Kloutsale helps your brand create deals that creators, agents, partners, and customers can share — so your products can move through trust, not just ads.',
    primaryCta: { label: 'Set up your BrandStore', intent: 'kloutsale.start' },
    secondaryCta: { label: 'How it works', intent: 'kloutsale.how' },
    editTags: {
      headline: 'kloutsale.hero.headline',
      subheadline: 'kloutsale.hero.subheadline',
      primaryCta: 'kloutsale.hero.cta.primary',
      secondaryCta: 'kloutsale.hero.cta.secondary',
    },
  },
  pitch: {
    headline: 'Add active sales to your passive marketing.',
    body: 'Your product should not have to shout to be found. Most brand growth budgets pay for attention and hope a sale follows. Kloutsale turns the same effort into trusted distribution: creators, agents, partners, and customers share your deals, customers buy, and you only share margin when value actually shows up.',
    editTag: 'kloutsale.pitch',
  },
  info: {
    headline: 'Your BrandStore. Your deals. Their reach.',
    body: 'You stay in control of products, pricing, shipping, and the customer relationship. Kloutsale gives you the tools to publish deals, set discount and commission, choose countries, and let creators, agents, and partners distribute through trust.',
    editTag: 'kloutsale.info',
  },
  examples: [
    {
      key: 'why',
      label: 'Why it matters',
      title: 'Paid attention fades. Trusted distribution compounds.',
      body: 'An ad runs and disappears. A creator who keeps your deal in their Katalag keeps introducing your product for months.',
      editTag: 'kloutsale.example.why',
    },
    {
      key: 'example',
      label: 'A simple example',
      title: 'A deal that pays for itself.',
      body: 'You set a 15% discount for the customer and a 10% commission for whoever helps sell it. A creator adds the deal to their Katalag, an agent introduces a partner brand, customers buy through trusted recommendations — and you only pay on results.',
      editTag: 'kloutsale.example.simple',
    },
    {
      key: 'next',
      label: 'What to do next',
      title: 'Three steps to live.',
      body: 'Create your BrandStore, publish your first deal, and invite the creators, agents, or partners who already align with your brand.',
      editTag: 'kloutsale.example.next',
    },
  ],
  instructions: {
    headline: 'Go live in a few clear steps.',
    steps: [
      { label: 'Create your BrandStore', body: 'Set your identity, country, and shipping basics.', editTag: 'kloutsale.steps.store' },
      { label: 'Add your products', body: 'Bring in the items you want to sell, with pricing and inventory.', editTag: 'kloutsale.steps.products' },
      { label: 'Create your first deal', body: 'Bundle the products and the offer you want trusted people to share.', editTag: 'kloutsale.steps.deal' },
      { label: 'Set discount, commission, country, and shipping', body: 'Choose the terms that work for your margin and the markets you serve.', editTag: 'kloutsale.steps.terms' },
      { label: 'Publish the deal', body: 'Make it live so creators, agents, partners, and customers can find it.', editTag: 'kloutsale.steps.publish' },
      { label: 'Let trusted people share it', body: 'Invite creators, agents, partners, and customers — or let them adopt it from discovery.', editTag: 'kloutsale.steps.share' },
      { label: 'Track orders, fulfillment, and sales', body: 'Fulfill, add tracking, and see sales, discounts, commissions, shipping, taxes, and fees in your dashboard.', editTag: 'kloutsale.steps.track' },
    ],
    editTag: 'kloutsale.instructions',
  },
  finalCta: {
    headline: 'Turn your best offers into active sales channels.',
    body: 'Set up your BrandStore and publish a deal worth sharing.',
    primaryLabel: 'Set up your BrandStore',
    secondaryLabel: 'See how it works',
    editTag: 'kloutsale.final-cta',
  },
  notes: [
    'Backward-compat: apps/koordinator-app/src/pages/landing/kloutsaleLandingContent.ts still owns the live arrays (navLinks, heroStats, steps, multiplier*, footerColumns) consumed by the current Kloutsale landing. This content file is the new communication-layer source for future migration.',
  ],
};

export default kloutsaleHome;